import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset the window to the top on every route change. Without this, navigating
// between pages inherits the previous page's scroll position (so a long page
// can open scrolled to the bottom). Runs before paint to avoid a visible jump.
export function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
